import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { AbstractModuleAdapter } from "../abstract";
import { Direction, ModuleConnectorAdapter } from "../connector";
export class ModuleGainAdapter extends AbstractModuleAdapter {
    #parameterGain;
    #voltageInput;
    #voltageOutput;
    constructor(context, box) {
        super(context, box);
        this.#parameterGain = this.parameters.createParameter(box.gain, ValueMapping.DefaultDecibel, StringMapping.numeric({ unit: "db" }), "Gain");
        this.#voltageInput = ModuleConnectorAdapter.create(context.boxAdapters, box.voltageInput, Direction.Input, "Input");
        this.#voltageOutput = ModuleConnectorAdapter.create(context.boxAdapters, box.voltageOutput, Direction.Output, "Output");
    }
    get parameterGain() { return this.#parameterGain; }
    get voltageInput() { return this.#voltageInput; }
    get voltageOutput() { return this.#voltageOutput; }
    get inputs() {
        return [this.#voltageInput];
    }
    get outputs() {
        return [this.#voltageOutput];
    }
}
